(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('click',event=>{if(event.target.closest('[data-zf-open-signup]')){window._klOnsite=window._klOnsite||[];window._klOnsite.push(['openForm','SawydL']);}});
function zfShowOfferTab(){let dismissed=false;try{dismissed=Number(localStorage.getItem('zf-offer-dismissed-until'))>Date.now();}catch(e){}document.querySelectorAll('[data-zf-offer-tab]').forEach(tab=>{tab.hidden=dismissed;});}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',zfShowOfferTab);}else{zfShowOfferTab();}
document.addEventListener('shopify:section:load',zfShowOfferTab);
document.addEventListener('click',event=>{const close=event.target.closest('[data-zf-dismiss-offer]');if(close){close.closest('[data-zf-offer-tab]').hidden=true;try{localStorage.setItem('zf-offer-dismissed-until',String(Date.now()+7*24*60*60*1000));}catch(e){}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zefra-mount-explorer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zefra-mount-explorer')) customElements.define('zefra-mount-explorer', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const button = this.querySelector('button'), frame = this.querySelector('iframe');
    this.frame = frame;
    this.syncArcadeViewport = () => {
      if (!this.arcadeFocus) return;
      const viewport = window.visualViewport, height = Math.round(viewport?.height || innerHeight);
      frame.style.height = height + 'px'; frame.style.top = (viewport?.offsetTop || 0) + 'px';
      frame.contentWindow?.postMessage({type: 'zefra-arcade-viewport', active: true, height}, location.origin);
    };
    this.setArcadeFocus = active => {
      active = active && matchMedia('(max-width:900px)').matches;
      if (active && !this.arcadeFocus) {
        this.focusSaved = {frameStyle: frame.getAttribute('style'), hostStyle: this.getAttribute('style'), overflow: document.documentElement.style.overflow, bodyOverflow: document.body.style.overflow, scrollX, scrollY};
        this.arcadeFocus = true; frame.setAttribute('data-arcade-focused', '');
        Object.assign(frame.style, {position: 'fixed', left: '0', right: '0', bottom: 'auto', width: '100vw', maxWidth: 'none', margin: '0', zIndex: '2147483000', background: '#f5fbfe'});
        this.style.position = 'relative'; this.style.zIndex = '2147482999';
        document.documentElement.style.overflow = document.body.style.overflow = 'hidden';
        window.addEventListener('resize', this.syncArcadeViewport); window.visualViewport?.addEventListener('resize', this.syncArcadeViewport);
      } else if (!active && this.arcadeFocus) {
        this.arcadeFocus = false; frame.removeAttribute('data-arcade-focused');
        for (const [element, value] of [[frame, this.focusSaved.frameStyle], [this, this.focusSaved.hostStyle]]) value === null ? element.removeAttribute('style') : element.setAttribute('style', value);
        document.documentElement.style.overflow = this.focusSaved.overflow; document.body.style.overflow = this.focusSaved.bodyOverflow;
        window.removeEventListener('resize', this.syncArcadeViewport); window.visualViewport?.removeEventListener('resize', this.syncArcadeViewport);
        window.scrollTo({left: this.focusSaved.scrollX, top: this.focusSaved.scrollY, behavior: 'instant'});
        this.focusSaved = null;
      }
      if (this.arcadeFocus) this.syncArcadeViewport();
      else frame.contentWindow?.postMessage({type: 'zefra-arcade-viewport', active: false, height: innerHeight}, location.origin);
    };
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      frame.hidden = !open; button.setAttribute('aria-expanded', String(open));
      if (open && !frame.srcdoc) { frame.srcdoc = frame.dataset.document; delete frame.dataset.document; }
      if (open) frame.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth', block: 'start'});
    });
    this.onMountLink = event => {
      const link = event.target.closest('a[href*="explore-mistone-3d"]');
      if (!link || this.id !== 'explore-mistone-3d') return;
      event.preventDefault(); const url = new URL(link.href), index = url.searchParams.has('mount') ? Number(url.searchParams.get('mount')) : null;
      if (button.getAttribute('aria-expanded') !== 'true') button.click();
      frame.scrollIntoView({behavior: 'smooth', block: 'start'});
      const send = () => { if (index !== null) frame.contentWindow.postMessage({type: 'zefra-select-mount', index}, location.origin); };
      frame.addEventListener('load', send, {once: true}); send();
    };
    document.addEventListener('click', this.onMountLink);
    this.onMessage = event => {
      if (event.origin !== location.origin || event.source !== frame.contentWindow) return;
      if (event.data?.type === 'zefra-arcade-focus') { this.setArcadeFocus(event.data.active === true); return; }
      if (!this.arcadeFocus && event.data?.type === 'zefra-mount-height' && Number.isFinite(event.data.height)) frame.style.height = Math.min(5000, Math.max(650, event.data.height + 4)) + 'px';
    };
    window.addEventListener('message', this.onMessage);
    if (this.dataset.dedicated === 'true') {
      const index = Number(new URLSearchParams(location.search).get('mount'));
      frame.addEventListener('load', () => { if (Number.isInteger(index) && index >= 0 && index < 8) frame.contentWindow.postMessage({type: 'zefra-select-mount', index}, location.origin); }, {once: true});
      frame.hidden = false; button.setAttribute('aria-expanded', 'true'); frame.srcdoc = frame.dataset.document; delete frame.dataset.document;
    }
  }
  disconnectedCallback() {
    this.setArcadeFocus?.(false);
    document.removeEventListener('click', this.onMountLink); window.removeEventListener('message', this.onMessage); this.ready = false;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zefra-mount-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zefra-mount-selector')) {
    customElements.define('zefra-mount-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.viewer = this.querySelector('model-viewer');
        this.stage = this.querySelector('[data-stage]');
        this.poster = this.querySelector('[data-poster]');
        this.status = this.querySelector('[data-status]');
        this.rotate = this.querySelector('[data-rotate]');
        this.retry = this.querySelector('[data-retry]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.sequence = 0;
        this.paused = false;
        this.started = false;
        this.visible = false;
        this.graphicsReady = false;
        this.urls = new Map();
        this.listen = (target, type, listener) => target.addEventListener(type, listener, {signal: this.signal});
        this.tabs.forEach((tab, index) => {
          tab.disabled = false;
          this.listen(tab, 'click', () => this.select(index));
          this.listen(tab, 'keydown', event => {
            let next;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + this.tabs.length - 1) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.tabs[next].focus({preventScroll: true});
            this.select(next);
          });
        });
        this.listen(this.rotate, 'click', () => { this.paused = !this.paused; this.syncMotion(); });
        this.listen(this.retry, 'click', () => {
          if (this.contextLost) this.showFailure(this.tabs[this.index]);
          this.loadSelection();
        });
        this.listen(this.reduced, 'change', () => this.syncMotion());
        this.listen(document, 'visibilitychange', () => this.syncMotion());
        this.listen(this.viewer, 'error', event => {
          if (this.stage.getAttribute('aria-busy') === 'true') return;
          if (event.detail?.type === 'webglcontextlost') {
            this.contextLost = true;
            this.status.textContent = this.dataset.failed;
            this.retry.hidden = false;
            this.syncMotion();
            return;
          }
          this.showFailure(this.tabs[this.index]);
        });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible && !this.started) { this.started = true; this.loadSelection(); }
          this.syncMotion();
        }, {threshold: 0.08});
        this.observer.observe(this.stage);
      }
      select(index) {
        if (index === this.index) return;
        this.index = index;
        this.sequence++;
        this.request?.abort();
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
        });
        const tab = this.tabs[index];
        const roster = tab.parentElement;
        if (roster.scrollWidth > roster.clientWidth) roster.scrollTo({left: tab.offsetLeft - roster.offsetLeft - (roster.clientWidth - tab.offsetWidth) / 2, behavior: this.reduced.matches ? 'instant' : 'smooth'});
        this.poster.src = tab.dataset.icon;
        this.poster.alt = tab.dataset.title;
        this.querySelector('[data-position]').textContent = String(index + 1).padStart(2, '0') + ' / ' + String(this.tabs.length).padStart(2, '0');
        this.clearModel();
        if (this.started) this.loadSelection();
      }
      clearModel() {
        this.contextLost = false;
        delete this.stage.dataset.loaded;
        this.viewer.autoRotate = false;
        this.viewer.setAttribute('aria-hidden', 'true');
        this.viewer.tabIndex = -1;
        this.rotate.hidden = true;
        this.retry.hidden = true;
      }
      async runtime() {
        if (customElements.get('model-viewer')) return;
        if (!window.zefraSelectorRuntime) window.zefraSelectorRuntime = import(this.dataset.runtime).catch(error => { window.zefraSelectorRuntime = null; throw error; });
        await window.zefraSelectorRuntime;
      }
      async model(tab, signal) {
        if (this.urls.has(tab.dataset.handle)) return this.urls.get(tab.dataset.handle);
        const parts = await Promise.all(tab.dataset.parts.split('|').map(async url => {
          const response = await fetch(url, {signal});
          if (!response.ok) throw new Error('Model download failed');
          const data = await response.json();
          return Uint8Array.from(atob(data.data), character => character.charCodeAt(0));
        }));
        const blob = await new Response(new Blob(parts).stream().pipeThrough(new DecompressionStream('gzip')), {headers: {'Content-Type': 'model/gltf-binary'}}).blob();
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        const url = URL.createObjectURL(blob);
        this.urls.set(tab.dataset.handle, url);
        return url;
      }
      retainModels(handle) {
        const url = this.urls.get(handle);
        this.urls.delete(handle);
        this.urls.set(handle, url);
        while (this.urls.size > 2) {
          const oldest = this.urls.keys().next().value;
          URL.revokeObjectURL(this.urls.get(oldest));
          this.urls.delete(oldest);
        }
      }
      showFailure(tab) {
        this.clearModel();
        this.status.textContent = this.dataset.failed;
        this.retry.hidden = false;
        const cached = this.urls.get(tab.dataset.handle);
        if (cached) { URL.revokeObjectURL(cached); this.urls.delete(tab.dataset.handle); }
      }
      async loadSelection() {
        const tab = this.tabs[this.index];
        const sequence = ++this.sequence;
        this.request?.abort();
        this.request = new AbortController();
        const signal = this.request.signal;
        this.clearModel();
        this.status.textContent = this.dataset.loading;
        this.stage.setAttribute('aria-busy', 'true');
        try {
          if (!this.graphicsReady) {
            const canvas = document.createElement('canvas');
            const gl = canvas.getContext('webgl2');
            if (gl) gl.getExtension('WEBGL_lose_context')?.loseContext();
            if (!gl) {
              this.status.textContent = this.dataset.unavailable;
              this.retry.hidden = false;
              return;
            }
            this.graphicsReady = true;
          }
          if (!window.DecompressionStream) {
            this.status.textContent = this.dataset.unavailable;
            this.retry.hidden = false;
            return;
          }
          await this.runtime();
          if (signal.aborted) return;
          const Viewer = customElements.get('model-viewer');
          Viewer.meshoptDecoderLocation = this.dataset.decoder;
          if ((navigator.maxTouchPoints > 0 || matchMedia('(any-pointer: coarse)').matches) && 'modelCacheSize' in Viewer) Viewer.modelCacheSize = 1;
          const url = await this.model(tab, signal);
          if (signal.aborted || sequence !== this.sequence) return;
          await new Promise((resolve, reject) => {
            const finish = error => { cleanup(); error ? reject(error) : resolve(); };
            const loaded = () => { if (this.viewer.src === url) finish(); };
            const failed = () => finish(new Error('Model load failed'));
            const aborted = () => finish(new DOMException('Aborted', 'AbortError'));
            const timeout = setTimeout(failed, 25000);
            const cleanup = () => { clearTimeout(timeout); this.viewer.removeEventListener('load', loaded); this.viewer.removeEventListener('error', failed); signal.removeEventListener('abort', aborted); };
            this.viewer.addEventListener('load', loaded);
            this.viewer.addEventListener('error', failed);
            signal.addEventListener('abort', aborted, {once: true});
            if (this.viewer.src === url && this.viewer.loaded) finish();
            else this.viewer.src = url;
          });
          if (signal.aborted || sequence !== this.sequence) return;
          this.viewer.cameraOrbit = '30deg 70deg auto';
          this.viewer.resetTurntableRotation(0);
          this.viewer.jumpCameraToGoal();
          this.viewer.alt = tab.dataset.title;
          this.viewer.removeAttribute('aria-hidden');
          this.viewer.tabIndex = 0;
          this.stage.dataset.loaded = tab.dataset.handle;
          this.rotate.hidden = false;
          this.status.textContent = this.dataset.ready.replace('{mount}', tab.dataset.title);
          this.retainModels(tab.dataset.handle);
          this.syncMotion();
        } catch (error) {
          if (signal.aborted || sequence !== this.sequence) return;
          this.showFailure(tab);
        } finally {
          if (sequence === this.sequence) this.stage.removeAttribute('aria-busy');
        }
      }
      syncMotion() {
        const stopped = this.paused || this.reduced.matches;
        this.viewer.autoRotate = !!this.stage.dataset.loaded && !stopped && !this.contextLost && !!this.visible && !document.hidden;
        this.rotate.setAttribute('aria-pressed', String(stopped));
        this.rotate.textContent = this.reduced.matches ? this.dataset.motionPaused : stopped ? this.dataset.play : this.dataset.pause;
        this.rotate.disabled = this.reduced.matches;
      }
      disconnectedCallback() {
        this.sequence++;
        this.request?.abort();
        this.controller?.abort();
        this.observer?.disconnect();
        this.viewer.autoRotate = false;
        this.viewer.removeAttribute('src');
        this.urls?.forEach(url => URL.revokeObjectURL(url));
        this.urls?.clear();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zefra-video-guides"] && !Shopify.designMode) return;
  try {
    
function resetZefraYouTube(except) {
  document.querySelectorAll('[data-zf-youtube]').forEach(media => {
    if (media === except) return;
    media.querySelector('iframe')?.remove();
    media.querySelector('[data-zf-video-trigger]').hidden = false;
  });
}
function initZefraGuides(root) {
  root.querySelectorAll('[data-zf-guides]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    section.querySelectorAll('[data-zf-video-trigger]').forEach(cover => {
      cover.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const media = cover.closest('[data-zf-youtube]');
        if (!/^[A-Za-z0-9_-]{11}$/.test(media.dataset.videoId)) return;
        event.preventDefault();
        resetZefraYouTube(media);
        document.querySelectorAll('.zf-guides video').forEach(video => video.pause());
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${media.dataset.videoId}?rel=0&autoplay=1&playsinline=1`;
        iframe.title = media.dataset.videoTitle;
        iframe.width = '560';
        iframe.height = '315';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.allowFullscreen = true;
        iframe.tabIndex = 0;
        cover.hidden = true;
        media.appendChild(iframe);
        iframe.focus();
      });
    });
    section.querySelectorAll('video').forEach(video => video.addEventListener('play', () => {
      resetZefraYouTube();
      document.querySelectorAll('.zf-guides video').forEach(other => { if (other !== video) other.pause(); });
    }));
  });
}
initZefraGuides(document);
document.addEventListener('shopify:section:load', event => initZefraGuides(event.target.parentElement));

  } catch(e) { console.error(e); }
})();
})();
